import React, { Component } from 'react';
import { AbstractChart } from 'containers/charts/AbstractChart';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { isEqual, groupBy, sortBy } from 'lodash';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';

class DemographicsBarChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data);
    }

    render() {
        const series = [];
        const { chartRef } = this;
        const { orderedColors } = this.props.theme;
        const {
            category = 'age',
            subCategory = 'gender',
            y = 'engagement_rate',
            enableLegend = true,
            data, title,
            xAxisLabel, yAxisLabel,
            yAxisOptions, xAxisType,
            exportName, toolTipOptions
        } = this.props;

        const categories = [
            ...new Set(data.map(r => helpers.convertToDisplayValue(r[category])))
        ].sort();
        const bySubCategory = groupBy(data, subCategory);

        // Backfill data
        // Since we are using named categories, we have to have an entry for every
        // category in the series.
        Object.entries(bySubCategory).forEach((entry) => {
            if (entry[1].length !== categories.length) {
                const entryCategories = entry[1].map(e => e[category]);
                categories.filter(c => !entryCategories.includes(c)).forEach((c) => {
                    entry[1].push({ [category]: c, [subCategory]: entry[0], [y]: 0 });
                });
            }
        });

        Object.entries(bySubCategory).forEach((entry, index) => {
            // entry([name(female, male, uncategorized), row])
            series.push({
                type: 'column',
                ...(this.props.yOptions || {}),
                name: helpers.convertToDisplayValue(entry[0]),
                color: orderedColors[index % orderedColors.length],
                data: sortBy(entry[1], category).map(r => r[y])
            });
        });

        const xAxis = helpers.xAxisConfig({
            type: xAxisType,
            xAxisLabel,
            options: { categories }
        });

        const yAxis = helpers.yAxisConfig({
            yAxisLabel,
            options: { ...(yAxisOptions || {}) }
        });

        return (
            <ContentTile padding={helpers.contentPadding('chart')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={exportName}
                    config={{
                        meta: {
                            title
                        },
                        credits: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        chart: {
                            style: {
                                padding: 0
                            }
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        tooltip: {
                            ...(toolTipOptions || {}),
                            shared: true,
                            followPointer: true
                        },
                        legend: {
                            enabled: enableLegend,
                            itemStyle: {
                                color: this.props.theme.colors.darkgray
                            }
                        },
                        plotOptions: {
                            series: {
                                animation: {
                                    duration: this.props.animateDuration
                                },
                                shadow: false,
                            },
                            column: {
                                borderWidth: 0
                            }
                        },
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

DemographicsBarChart.propTypes = {
    category: PropTypes.string,
    subCategory: PropTypes.string,
    enableLegend: PropTypes.bool,
    title: PropTypes.string.isRequired,
    xAxisLabel: PropTypes.string,
    yAxisLabel: PropTypes.string,
    yAxisOptions: PropTypes.object,
    xAxisType: PropTypes.string,
    toolTipOptions: PropTypes.object,
    exportName: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
        age: PropTypes.string,
        gender: PropTypes.string
    })),
};

export default withTheme(DemographicsBarChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/DemographicsBarChart.js